import * as t from 'io-ts';
import { optional } from '@/api/validators/helper';

const playersInfo = t.type({
  name: optional(t.string),
  shortName: optional(t.string),
  playerId: optional(t.string),
  icon: optional(t.string),
  countryCode: optional(t.string),
});

export const playersInfoApiResponse = t.array(playersInfo);
export type TennisPlayersDetails = t.TypeOf<typeof playersInfo>;
export type TennisPlayersInfo = t.TypeOf<typeof playersInfoApiResponse>;
